<template>
  <div id="nova">
    <MainHeader />

    <!-- Content -->
    <div data-testid="content">
      <div
        class="left-0 hidden h-auto min-h-full w-60 bg-[#002d5f] px-3 py-5 lg:absolute lg:top-[56px] lg:block"
      >
        <MainMenu />
      </div>

      <div class="p-4 md:py-8 md:px-12 lg:ml-60">
        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '@/layouts/Footer'
import MainHeader from '@/layouts/MainHeader'

export default {
  components: {
    MainHeader,
    Footer,
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
      let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('forceProfile')){
        Nova.$toasted.show(this.__('Please update your profile'), {
            duration: 5000,
            type: 'danger',
        })
    }
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },
}
</script>
